<template>
  <div>
    <h2>Description</h2>
    <FormKit
      type="checkbox"
      label="Descriptions partagées"
      name="isSharedDescriptions"
      :disabled="isDisabled"
    />
    <ProductDescriptionFormCollection
      :descriptions="descriptions"
      ref="ProductDescriptionFormCollectionRef"
      name="product_description"
      :isDisabled="isDisabled"
    />
    <div class="content-end">
      <FormKit
        type="button"
        label="Enregistrer les descriptions"
        @click="submitDescription"
        :disabled="isDisabled"
      />
    </div>
  </div>
  <br>
  <h2>Images</h2>
  <FormKit
    type="checkbox"
    label="Images partagées"
    name="isSharedImages"
    :disabled="isDisabled"
  />
  <FormKit
    id="repeater"
    name="images"
    type="repeater"
    label="Images"
    v-model="repeaterImages"
    add-label="Ajouter une image"
    :disabled="isDisabled"
  >
    <template #default="{ index }">
      <FormKit
        @change="selectImages(index)"
        type="file"
        :label="`${index + 1}. Image`"
        name="product_image"
        accept=".png,.jpg,.jpeg"
        help="Séléctionez les images à uploader."
        inner-class="max-w-none"
        max="1"
        :disabled="isDisabled"
      >
        <template #fileItem="{ value }">
          <div class="grid grid-cols-6 grid-flow-row gap-4">
            <div v-for="(item) in value" :key="item.name" class="relative">
              <img :src="item.url?  item.url: createImagePreview(item.file)" alt="" class="rounded-md">
            </div>
          </div>
        </template>
      </FormKit>
      <FormKit
        type="hidden"
        name="uuid"
      />
    </template>

    <template #removeControl="{ index }">
      <span @click="deleteImage(index)" v-if="repeaterImages.length > 1" class="cursor-pointer formkit-remove-icon block w-5 my-1 formkit-icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M14.5,4H1.5c-.28,0-.5-.22-.5-.5s.22-.5,.5-.5H14.5c.28,0,.5,.22,.5,.5s-.22,.5-.5,.5Z" fill="currentColor"></path><path d="M11.02,3.81l-.44-1.46c-.06-.21-.26-.36-.48-.36H5.9c-.22,0-.41,.14-.48,.36l-.44,1.46-.96-.29,.44-1.46c.19-.64,.77-1.07,1.44-1.07h4.2c.67,0,1.24,.43,1.44,1.07l.44,1.46-.96,.29Z" fill="currentColor"></path><path d="M11.53,15H4.47c-.81,0-1.47-.64-1.5-1.45l-.34-9.87,1-.03,.34,9.87c0,.27,.23,.48,.5,.48h7.07c.27,0,.49-.21,.5-.48l.34-9.87,1,.03-.34,9.87c-.03,.81-.69,1.45-1.5,1.45Z" fill="currentColor"></path><path d="M6.5,11.62c-.28,0-.5-.22-.5-.5V7.12c0-.28,.22-.5,.5-.5s.5,.22,.5,.5v4c0,.28-.22,.5-.5,.5Z" fill="currentColor"></path><path d="M9.5,11.62c-.28,0-.5-.22-.5-.5V7.12c0-.28,.22-.5,.5-.5s.5,.22,.5,.5v4c0,.28-.22,.5-.5,.5Z" fill="currentColor"></path></svg></span>
    </template>
  </FormKit>
  <div class="content-end">
    <FormKit
      type="button"
      label="Enregistrer les images"
      @click="submitImages"
      :disabled="!updatedImages"
    />
  </div>
  <hr>
  <br><br>
  <FormKit
    type="hidden"
    name="descriptionListUuid"
    v-model="stepUuidList.descriptionsUuid"
    :disabled="isDisabled"
  />
</template>
<script setup lang="ts">
// IMPORTS

import { reactive, ref } from "vue";
import swal from '@/_helpers/swal'
import ProductDescriptionFormCollection from "../../description/ProductDescriptionFormCollection.vue";
import { ProductDescription } from "@/models/product/description/ProductDescription";
import ApiService from "@/_services/api.service"

// VARIABLES

const stepUuidList = ref({
  descriptionsUuid: [],
});

const props = defineProps({
  descriptions: {
    type: Object as () => ProductDescription[],
    required: true,
  },
  images: {
    required: true,
  },
  isDisabled: { type: Boolean, default: false },
});
defineExpose({
  submitStep,
})
const descriptions = reactive(props.descriptions);
const ProductDescriptionFormCollectionRef = ref();
const repeaterImages = ref();
let updatedImages = ref(false);
const images = reactive(props.images);

// FUNCTIONS

async function submitDescription() {
  stepUuidList.value.descriptionsUuid = await ProductDescriptionFormCollectionRef.value.submitProductDescriptions();
}

async function submitStep() {
  await submitImages();
  await submitDescription();
}

function selectImages(index) {
  let imagesUploaded = repeaterImages.value;
  imagesUploaded[index].uuid = "";
  updatedImages.value = true;
}

const createImagePreview = (file) => {
  return (file && file.type.startsWith('image/')) ? URL.createObjectURL(file) : null;
};

async function submitImages() {

  updatedImages.value = false;
  let imagesUploaded = repeaterImages.value;

  imagesUploaded.forEach(async (image, index) => {
    const imageFile = image?.product_image[0]?.file;
    if(image.uuid || !imageFile) return;

    const file = new FormData();
    file.append('file', imageFile);
    file.append('position', index);

    let apiAction = await ApiService.post("images",  file);
    const data = apiAction.data.data;

    images.push({ name: apiAction.data.data })
    image.uuid = data.uuid;
    swal.success('', 'Les images ont été bien enregistrées')
  })
}

async function deleteImage(imageIndex: number) {
  updatedImages.value = true;
  const imageToRemove = repeaterImages.value.splice(
    imageIndex,
    1
  )[0];

  if (imageToRemove.uuid) {
    await ApiService.delete("images/" + imageToRemove.uuid);
  }
}
</script>